module.exports = __webpack_public_path__ + "img/stella-we-chat.3948fcbe.png";